import React, { useEffect, useState } from "react";
import { OptionRenderType, StewartAutocompleteEventType } from "controls/global/stewart-multi-select/StewartMultiSelect";
import StewartMultiSelectField from "controls/global/stewart-multi-select/StewartMultiSelectField";
import { useLookup, useUwaLookup } from "utils/context/LookupContext";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
import { SelectFieldOption } from "controls/global/select-field/SelectInput";

interface Props {
  // schema: string;
  name: string;
  disabled?: boolean;
  onChange?: (
    e: StewartAutocompleteEventType,
    value: OptionRenderType[]
  ) => void;  
}

export default function UWAPropertyTypeField ({
  // schema,
  name,
  disabled,
  onChange
}: Props) {
  const { getValues } = useFormWrapper();
  const [,{getUwaPropertyTypes}] = useLookup();
  const [{uwaPropertyTypes},] = useUwaLookup();
  const [ defaultValue, setDefaultValue ] = useState<SelectFieldOption[]>();

  const currentValue: SelectFieldOption[] = getValues(name);

  React.useEffect(()=> {
    if (uwaPropertyTypes?.length === 0) {
      getUwaPropertyTypes();
    }
  },[uwaPropertyTypes, getUwaPropertyTypes])

  // console.log(uwaPropertyTypes);
  // console.log("currentValue: ", currentValue);

  useEffect(() => {
    // console.log("currentValue - initial: ", currentValue);
    // console.log("uwaPropertyTypes: ", uwaPropertyTypes);
    // Popoulate Text and filter out null value
    const filteredCurrentValue = currentValue
      ?.filter((elem) => !!elem.value)
      ?.map((elem) => {
        const uwaPropertyType = uwaPropertyTypes?.find((o) => o.value === elem.value);
        if (uwaPropertyType) {
          elem.text = uwaPropertyType.text;
        }
        return elem;
      });
    // console.log("filteredCurrentValue: ", filteredCurrentValue);
    setDefaultValue(filteredCurrentValue || []);
  }, [currentValue, uwaPropertyTypes]);

  return (
    <StewartMultiSelectField
      name={name}
      defaultValue={defaultValue} //{currentValue}
      label="Property Type*"
      options={uwaPropertyTypes} //PropertyTypes}
      onChange={(e, value) => {
        onChange && onChange(e, value);
      }}
      disabled={disabled}
    />
  );

}